import { Pipe, PipeTransform, Injectable } from '@angular/core';

declare function require(name: string);
const numToWords = require('number-to-words/numberToWords');

@Pipe({
  name: 'towords'
})
@Injectable()
export class ToWordsPipe implements PipeTransform {

  transform(n: number): string {
    return numToWords.toWords(n, false);
  }
}
